var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCalendarEvent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3H17V2C17 1.4 16.6 1 16 1C15.4 1 15 1.4 15 2V3H9V2C9 1.4 8.6 1 8 1C7.4 1 7 1.4 7 2V3H5C3.3 3 2 4.3 2 6V20C2 21.7 3.3 23 5 23H19C20.7 23 22 21.7 22 20V6C22 4.3 20.7 3 19 3ZM5 5H7V6C7 6.6 7.4 7 8 7C8.6 7 9 6.6 9 6V5H15V6C15 6.6 15.4 7 16 7C16.6 7 17 6.6 17 6V5H19C19.6 5 20 5.4 20 6V9H4V6C4 5.4 4.4 5 5 5ZM19 21H5C4.4 21 4 20.6 4 20V11H20V20C20 20.6 19.6 21 19 21Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15C10 16.1046 9.10457 17 8 17C6.89543 17 6 16.1046 6 15C6 13.8954 6.89543 13 8 13C9.10457 13 10 13.8954 10 15Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCalendarEvent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconCalendarEvent.7d39483150531588639168f501ff809b.svg";